import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Header, Container, Row, Column, Box, Icons, Button } from '@generationtux/component-library';
import styled from 'styled-components';
import PreviewLayer from '../components/look-builder/preview/PreviewLayer';
import { previewLayerStyles } from '../components/look-builder/preview/previewLayerStyles';
import { products } from '../data/products';
import { bundles } from '../data/bundles';
import { scrollTop } from '../utils/utils';

const PreviewWrapper = styled.div`
  ${previewLayerStyles}
`;

const EditLook = styled(Box)`
  display: block;
  .look-image-group {
    transition: all 0.15s ease-out;
    transform-origin: center bottom;
    backface-visibility: hidden;
  }
  :hover {
    .look-image-group {
      cursor: pointer;
      opacity: 0.7;
      transform: scale(1.03);
    }
  }
`;

const makeLookLayers = look => {
  return products
    .filter(product => {
      if (
        look
          .filter(selectedItem => !selectedItem.isBundle)
          .map(selectedItem => selectedItem.activeItem)
          .indexOf(product.catalogNumber) > -1
      ) {
        return true;
      } else {
        return false;
      }
    })
    .concat(
      bundles
        .filter(bundle => {
          if (bundle.displayName.includes('RECOMMENDED') > 0) {
            return false;
          }
          return true;
        })
        .reduce((acc, bundle, index) => {
          bundle.products.map(product => {
            if (look.map(selectedItem => selectedItem.activeItem).indexOf(product.catalogNumber) > -1) {
              // map bundle products
              bundle.products.forEach(bundleProduct => {
                bundleProduct.type = bundleProduct.type.includes('Pant') ? 'Pants' : 'Jacket';
                bundleProduct.costToCustomer = bundle.cost;
                acc.push(bundleProduct);
              });
            }
            return acc;
          });
          return acc;
        }, [])
    );
};

const LookCard = ({ lookId, look }) => {
  const { push } = useHistory();
  const lookLayers = makeLookLayers(look);
  return (
    <Box shadowLevel={1} backgroundColor="white">
      <Box style={{ position: 'relative' }}>
        <EditLook
          onClick={() => {
            scrollTop();
            localStorage.setItem(
              'lookToEdit',
              JSON.stringify({ version: process.env.REACT_APP_LOCAL_STORAGE_VERSION, id: lookId, look: look })
            );
            push('/look-build');
          }}
        >
          <Box
            display="flex"
            flexFlow="wrap"
            justifyContent="space-between"
            alignItems="flex-start"
            p={[2, 3, 3, 3, 3, 3]}
            pb={[0, 0, 0, 0, 0, 0]}
            style={{ position: 'relative', zIndex: 2 }}
          >
            <Box>
              <Header type={3} size={4} mb={[1, 0, 0, 0, 0, 0]} textColor="gray">
                #{lookId}
              </Header>
            </Box>

            <Button size="xs" buttonType="info" outline>
              Edit Look
            </Button>
          </Box>
          <Box
            display="flex"
            px={2}
            justifyContent="center"
            alignItems="flex-start"
            style={{ position: 'relative', zIndex: 1 }}
          >
            <Box className="look-image-group" style={{ position: 'relative', zIndex: 0 }}>
              <img
                src="https://gentux.imgix.net/1584373843_placeholder.png"
                alt="placeholder"
                className="placeholder"
              />
              {lookLayers.map((layer, i) => (
                <PreviewLayer key={layer + i} product={layer} />
              ))}
            </Box>
          </Box>
        </EditLook>
      </Box>
    </Box>
  );
};

const Looks = props => {
  const { push } = useHistory();
  const [looks] = useState(
    () => localStorage.getItem('localState') !== null && [...JSON.parse(localStorage.getItem('localState'))['looks']]
  );

  return (
    <Box style={{ minHeight: '110vh' }}>
      <Container my={[4, 4, 4, 5, 5, 5]}>
        <Row flexWrap>
          <Column column={12}>
            <Box display="flex" alignItems="center" justifyContent="center">
              <Header type={1} size={3} headline>
                Saved Looks
              </Header>
              <Box py={3} mx={4} backgroundColor="grayDark" style={{ width: 1 }} />
              <Header type={2} size={4} mt={2}>
                {looks.length || 0}
              </Header>
            </Box>
          </Column>
        </Row>
      </Container>
      <Container my={[3, 3, 3, 3, 4, 5]}>
        <Row flexWrap>
          {looks &&
            looks.length > 0 &&
            looks.map(look => (
              <Column mb={4} column={6} columnXs={4} columnMd={3} columnLg={3} key={look.id}>
                <PreviewWrapper>
                  <LookCard lookId={look.id} look={look.look} />
                </PreviewWrapper>
              </Column>
            ))}
          <Column mb={4} column={6} columnXs={4} columnMd={3} columnLg={3} display="flex">
            <Button
              py={5}
              onClick={() => {
                scrollTop();
                push('/look-build');
              }}
              buttonType="info"
              style={{ flexGrow: 1 }}
            >
              <Icons.Plus mr={1} /> Add&nbsp;Look
            </Button>
          </Column>
        </Row>
      </Container>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Button
          outline
          buttonType="link"
          onClick={() => {
            scrollTop();
            localStorage.removeItem('localState');
            push('/');
          }}
        >
          Clear All Looks
        </Button>
      </Box>
    </Box>
  );
};

export default Looks;
